import { QUANTITY_PER_PAGE } from "views/components/Schedules/utils/constants";

export const getFormattedCaption = dataPaginator => {
    const { currentPage, totalRecords } = dataPaginator;
    const currentRecord = (currentPage * QUANTITY_PER_PAGE);
    const firstRecord = currentRecord - 6,
        lastRecord = currentRecord - totalRecords > 0 ? totalRecords : currentRecord;
    return `${firstRecord} - ${lastRecord} de ${totalRecords}`;
}